import { memo } from 'react';

interface PlusIndicatorIconProperties {
  size?: number;
}

/** Figma: plus (14×14) */
const PlusIndicatorIcon = memo(({ size = 14 }: PlusIndicatorIconProperties) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 14 14'
    fill='none'
    aria-hidden
  >
    <path d='M7 2.5V11.5M2.5 7H11.5' stroke='#000000' strokeWidth='1.5' strokeLinecap='round' />
  </svg>
));

PlusIndicatorIcon.displayName = 'PlusIndicatorIcon';

export default PlusIndicatorIcon;
